
<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      persistent
      scrollable
      transition="dialog-bottom-transition"
    >
      <v-card style="border-radius:12px">
        <v-card-title class="pa-0">
          <v-app-bar dense dark color="primary">
            <v-btn icon dark @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Tratativas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="clickSubmit()">Salvar</v-btn>
            </v-toolbar-items>
          </v-app-bar>
        </v-card-title>
        <v-card-text>
          <v-sheet>
            <v-container>
              <div class="title">
                {{oneExecution.done_items[question].title}}
              </div>
              <div class="subtitle-1 use_enter mt-n5">
                {{oneExecution.done_items[question].sentence}}
              </div>
              <div>
                <v-divider></v-divider>
              </div>
              <v-form ref="unsuccessForm">
                <hint-fail v-if="oneExecution.done_items[question].hint"></hint-fail>
                <comment-fail v-if="oneExecution.done_items[question].needs_comment"></comment-fail>
                <photo-fail class="mb-5 px-5 py-2" v-if="oneExecution.done_items[question].photo == 1"
                  :style="photo_border1()" 
                ></photo-fail>
                <action-plan :rules="[rules.required]" v-model='action_plan_valid' v-if="oneExecution.done_items[question].action_plan_enabled"></action-plan>
              </v-form>
            </v-container>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'DialogUnsuccess',
  components: {
    HintFail: () => import('./Hint'),
    CommentFail: () => import('./Comment'),
    PhotoFail: () => import('../item_kind/PhotoItem'),
    ActionPlan: () => import('./ActionPlan'),
  },
  data() {
    return {
      dialog: true,
      required_photo: false,
      action_plan_valid: true,
      rules: {
        required: v => !!v || 'Campo é necessário',
      },
    }
  },
  methods: {
    photo_border1(){
      // console.log('ran');
      if (this.required_photo){
        if (this.oneExecution.done_items[this.question].photo_compressed || this.oneExecution.done_items[this.question].photo_original){
          return "border: solid 1px #ddd; border-radius: 10px"
        } else {
          return "border: solid 2px #f44336; border-radius: 10px"
        }
      }
      return "border: solid 1px #ddd; border-radius: 10px"
    },
    closeDialog() {
      // limpar as respostas de comment, photo, action-plan
      if (!this.oneExecution.done_items[this.question].unsuccess_saved){
        if (!this.oneExecution.done_items[this.question].had_comment){
          this.oneExecution.done_items[this.question].comment = null
        }
  
        if (this.oneExecution.done_items[this.question].photo == 1 && !this.oneExecution.done_items[this.question].photo_compressed_partial && typeof(this.oneExecution.done_items[this.question].photo_compressed) != 'string'){
          this.oneExecution.done_items[this.question].photo_compressed = ''
          this.oneExecution.done_items[this.question].photo_original = ''
        }
        
        if (this.oneExecution.done_items[this.question].action_plan_attributes && !this.oneExecution.done_items[this.question].action_plan_attributes.id){
          // console.log('had apatt');
          this.oneExecution.done_items[this.question].action_plan_attributes = null
        }
      }
      
      this.$emit("close");
    },
    customValidate(){
      let valid = true
      if (!this.action_plan_valid){
        valid = false
        let notification = {
          type: 'error', // 'success
          msg: `É necessario responder as perguntas obrigatórias do plano de ação` // success msg
        }
        this.addNotification(notification)
      }
      return valid
    },
    async clickSubmit() {
      if (this.$refs.unsuccessForm.validate() && this.customValidate() && (this.oneExecution.done_items[this.question].photo != 1 || (this.oneExecution.done_items[this.question].photo == 1 && this.oneExecution.done_items[this.question].photo_compressed))){
        if (this.oneExecution.done_items[this.question].action_plan_attributes){
          this.setActionPlan()
        }
        this.oneExecution.done_items[this.question].unsuccess_saved = true
        this.$emit("done");
      } else if(this.oneExecution.done_items[this.question].photo == 1 && !this.oneExecution.done_items[this.question].photo_compressed){
        let notification = {
          type: 'error', // 'success
          msg: `É necessario anexar a imagem` // success msg
        }
        this.required_photo = true
        this.addNotification(notification)
      } else {
        this.required_photo = false
      }
    },

    setActionPlan(){
      // this.oneExecution.done_items[this.question].action_plan_attributes.item_setup_id = this.oneExecution.done_items[this.question].item_setup_id; 
      this.oneExecution.done_items[this.question].action_plan_attributes.emitter_id = this.oneUser.employee.id;
      this.oneExecution.done_items[this.question].action_plan_attributes.solution_id = this.oneExecution.solution_id;
      this.oneExecution.done_items[this.question].action_plan_attributes.form_id = this.oneExecution.form_id;
      this.oneExecution.done_items[this.question].action_plan_attributes.info.from = this.oneUser.name;
      this.oneExecution.done_items[this.question].action_plan_attributes.dead_line = this.oneExecution.done_items[this.question].action_plan_attributes.info.when;
      let r = this.oneExecution.done_items[this.question].action_plan_attributes.receiver_ids
      let who = this.oneExecution.done_items[this.question].action_plan_attributes.info.who
      this.oneExecution.done_items[this.question].action_plan_attributes.info.who = (who && who.length)? who.map(w=>{
        const {id, name, email, user_id} = w
        return {id, name, email, user_id}
      }) : [];
      this.oneExecution.done_items[this.question].action_plan_attributes.receiver_ids = (r && r.length)? r : (who && who.length)? who.map(w=>w.id) : [];
    },

    ...mapActions({
      addNotification: 'Notification/add',
      // function: 'Module/action'
    })
  },
  computed: {
    photo_border() {
      if (this.oneExecution.done_items[this.question].photo_compressed){
        this.required_photo = false
        return "border: solid 1px #ddd; border-radius: 10px"
      } else if (this.required_photo){
        return "border: solid 2px #f44336; border-radius: 10px"
      }
      return "border: solid 1px #ddd; border-radius: 10px"
    },
    one_item(){
      return this.oneExecution.done_items[this.question]
    },
    ...mapState({
      oneUser: state => state.User.oneUser,
      question: state => state.Execution.question,
      oneExecution: state => state.Execution.oneExecution,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    'one_item.photo_original'(nv,ov) {
      if (nv){
        // console.error('has photp now');
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>
.use_enter {
    white-space: pre-line; /* or pre-line */
}
</style>
